import { createRouter, createWebHistory } from 'vue-router'
//import VueScrollTo from "vue-scrollto";
import HomeView from '../views/HomeView.vue'
import CatalogView from "@/views/CatalogView.vue";
import OfferAndPrivacyPolicyView from "@/views/additionalInformation/OfferAndPrivacyPolicyView.vue";
import UserAgreementView from "@/views/additionalInformation/UserAgreementView.vue";
import TermsOfExchangeAndRefundView from "@/views/additionalInformation/TermsOfExchangeAndRefundView.vue"
import PersonalDataProcessingPolicyView from "@/views/additionalInformation/PersonalDataProcessingPolicyView.vue"
import PublicOfferAgreementForLeAndIeView from "@/views/additionalInformation/PublicOfferAgreementForLeAndIeView.vue"
import RecipesView from "@/views/RecipesView.vue"
import Recipe1View from "@/views/Recipe1View.vue"
import Recipe2View from "@/views/Recipe2View.vue"
import MoreDetailsRoster7View from "@/views/moreDetails/MoreDetailsRoster7View.vue";
import MoreDetailsRoster9View from "@/views/moreDetails/MoreDetailsRoster9View.vue";
import MoreDetailsRoster17View from "@/views/moreDetails/MoreDetailsRoster17View.vue";
import MoreDetailsRoster23View from "@/views/moreDetails/MoreDetailsRoster23View.vue";

const routes = [
  {
    path: '/',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
    meta: {
      title: 'Главная'
    }
  },
  {
    path: "/home",
    name: 'home',
    component: HomeView
  },
  {
    path: "/catalog",
    name: 'catalog',
    component: CatalogView,
    meta: {
      title: 'Каталог'
    }
  },
  {
    path: "/recipes",
    name: 'recipes',
    component: RecipesView,
    meta: {
      title: 'Рецепты'
    }
  },
  {
    path: "/recipes/Roasted-quail-for-grilling-and-oven",
    name: 'recipe1',
    component: Recipe1View,
    meta: {
      title: 'Рецепт "Запечённые перепёлки (для гриля и духовки)"'
    }
  },
  {
    path: "/recipes/grilled-smoked-quail-recipe",
    name: 'recipe2',
    component: Recipe2View,
    meta: {
      title: 'Рецепт "Апельсиновые перепёлки горячего копчения в гриле"'
    }
  },
  {
    path: "/product/roaster-for-7-quails",
    name: 'roaster-for-7-quails',
    component: MoreDetailsRoster7View,
    meta: {
      title: 'Ростер для 7 перепёлок - купить у производителя'
    }
  },
  {
    path: "/product/roaster-for-9-quails",
    name: 'roaster-for-9-quails',
    component: MoreDetailsRoster9View,
    meta: {
      title: 'Ростер для 9 перепёлок - купить у производителя'
    }
  },
  {
    path: "/product/roaster-for-17-quails",
    name: 'roaster-for-17-quails',
    component: MoreDetailsRoster17View,
    meta: {
      title: 'Ростер для 17 перепёлок - купить у производителя'
    }
  },
  {
    path: "/product/roaster-for-23-quails",
    name: 'roaster-for-23-quails',
    component: MoreDetailsRoster23View,
    meta: {
      title: 'Ростер для 23 перепёлок - купить у производителя'
    }
  },
  {
    path: "/offerAndPrivacyPolicy",
    name: 'offerAndPrivacyPolicy',
    component: OfferAndPrivacyPolicyView,
    meta: {
      title: 'Оферта и политика конфиденциальности'
    }
  },
  {
    path: "/userAgreement",
    name: 'userAgreement',
    component: UserAgreementView,
    meta: {
      title: 'Пользовательское соглашение'
    }
  },
  {
    path: "/termsOfExchangeAndRefund",
    name: 'termsOfExchangeAndRefund',
    component: TermsOfExchangeAndRefundView,
    meta: {
      title: 'Условия обмена и возврата'
    }
  },
  {
    path: "/personal_data_policy",
    name: 'personalDataProcessingPolicy',
    component: PersonalDataProcessingPolicyView,
    meta: {
      title: 'Политика обработки персональных данных'
    }
  },
  {
    path: "/publicOfferAgreementForLeAndIe",
    name: 'publicOfferAgreementForLeAndIe',
    component: PublicOfferAgreementForLeAndIeView,
    meta: {
      title: 'Оферта для юр.лиц и ИП'
    }
  },
]


const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  // scrollBehavior(to, from, savedPosition) {
  //   if (to.name !== from.name) { // Сравниваем имена маршрутов
  //     if (savedPosition) {
  //       VueScrollTo.scrollTo("#app", 0, { offset: savedPosition.y });
  //       return savedPosition;
  //     } else {
  //       VueScrollTo.scrollTo("#app");
  //     }
  //   }
  // },
})

router.beforeEach(async (to, from, next) => {
  const { title } = to.meta;
  const brand = "AddGrill";
  document.title = `${title ? title + " | " + brand : brand}`;
  next();
});




export default router
